import {FC, useState} from "react";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import {faLinkSlash} from "@fortawesome/pro-solid-svg-icons";
import {ValidationError} from "../../../../lib/src/api/common/APIService";
import {useNavigate} from "react-router";
import {useApiService} from "../../../../lib/src/api/hooks/useApiService";
import config from "../../config";
import {getToken} from "@ventumsoftware/react-toolkit";
import {ProjectVisit} from "@traas/lib/src/api/dto/ProjectVisit";

export const UnlinkTaskFromProjectVisitModal: FC<{ visit: ProjectVisit, onUpdated?: () => void }> = (props) => {
  const navigate = useNavigate();
  const {projectVisitService} = useApiService(config, getToken, navigate)
  const [errors, setErrors] = useState<String[]>([])
  const unlinkTask  = async () => {
    await projectVisitService.unlinkTask(props.visit.id, {task: props.visit.taskId})
      .catch(e => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat())
        }
        throw e
      })
    props.onUpdated?.()
  }
  return <div>
    <div>Weet je zeker dat je de taak van het werkbezoek wilt ontkoppelen?</div>
    <ModalFooter text={'Ontkoppelen'} icon={faLinkSlash} onSubmit={unlinkTask} />
  </div>
}
